<div class="xux-tabs-body">
  <bs-datepicker-inline
          [bsValue]="_bsValue"
          [bsConfig]="dpConfig"
          [datesDisabled]="config.disabledDates"
          [minDate]="config.minDate"
          [maxDate]="config.maxDate"
          [dateCustomClasses]="customClasses"
          (bsValueChange)="onValueChange($event)">
  </bs-datepicker-inline>
</div>

<ul #monthSelector [class.hidden]="!showDropdown.month">
  <li *ngFor="let month of months"
      (click)="showMonth(month.number)"
      [class.disabled]="isDateDisabled(DateGranularity.MONTH, month.number)">
    {{month.name}}
  </li>
</ul>

<ul #yearsSelector [class.hidden]="!showDropdown.year">
  <ng-container *ngFor="let year of years">
    <li (click)="showYear(year)"
        *ngIf="!isDateDisabled(DateGranularity.YEAR, year)">
      {{year}}
    </li>
  </ng-container>
</ul>

<span
  #dayTooltipContainer
  *ngIf="config && config.dayTooltipTitles"
  [tooltip]="dayTooltipTitle"
  class="tooltip-target"
></span>
